// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"738a948d","453":"17f6cf7c","455":"e4f0a8d9","977":"c82af193"}[chunkId] + ".chunk.js";
};